import { c as e, i as t, l as n } from "./dist-C6rmHehb.js";
import * as r from "zod";
import { ZodError as i } from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var a = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var o = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, l = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(c(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = s(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : d({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, d = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, f = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = l(r), s = Object.entries(i).map(([t, i]) => d({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, p = /\{[^{}]+\}/g, m = ({ path: e, url: t }) => {
	let n = t, r = t.match(p);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, f({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${d({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, h = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = m({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function ee(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var te = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = f({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = d({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ne = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, re = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ie = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (re(t, n.name)) continue;
		let e = await te(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, _ = (e) => h({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = y(e.headers, t.headers), n;
}, ae = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, y = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? ae(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, b = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, oe = () => ({
	error: new b(),
	request: new b(),
	response: new b()
}), se = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), ce = { "Content-Type": "application/json" }, le = (e = {}) => ({
	...a,
	headers: ce,
	parseAs: "auto",
	querySerializer: se,
	...e
}), x = ((e = {}) => {
	let t = v(le(), e), n = () => ({ ...t }), r = (e) => (t = v(t, e), n()), i = oe(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: y(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ie({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: _(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: ee(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ne(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return o({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: ee(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: i,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(le({
	baseUrl: "https://presta.ecommerce.api.myparcel.nl",
	throwOnError: !0
})), S = r.enum(["MINUTES"]), C = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({ lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(r.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: r.tuple([r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	delegationError: r.object({
		reason: r.string().register(r.globalRegistry, { description: "Error reason." }),
		details: r.string().register(r.globalRegistry, { description: "More detailed information about the error." }).optional()
	}).register(r.globalRegistry, { description: "Delegation error." }),
	status: r.enum(["DELEGATION_REQUIRED"]).register(r.globalRegistry, { description: "Connection status which indicates that a connection authorization is required." })
}), w = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({
		lastCycle: r.object({
			extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
			successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
			transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
			successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
		}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
		schedule: r.object({
			transformAndLoad: r.boolean().register(r.globalRegistry, { description: "Whether orders should be automatically imported." }),
			unit: S.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
			value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
		}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
	}).register(r.globalRegistry, { description: "Order extraction configuration." }),
	fulfilmentPlatforms: r.tuple([r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	apiCredentialsLastTokens: r.object({ key: r.string().length(4).register(r.globalRegistry, { description: "API key." }) }).register(r.globalRegistry, { description: "Last N tokens when API credentials are used." }),
	status: r.enum(["DELEGATION_ISSUED"]).register(r.globalRegistry, { description: "Status for the connection with the sales channel for which orders will be extracted from." })
}), T = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({ lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(r.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: r.tuple([r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	authorizeUrl: r.url().register(r.globalRegistry, { description: "Authorization URL for the sales channel." }),
	status: r.enum(["DELEGATION_REQUESTED"]).register(r.globalRegistry, { description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed." })
}), E = r.union([
	r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(C),
	r.object({ status: r.literal("DELEGATION_ISSUED") }).and(w),
	r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(T)
]), D = r.object({
	fulfilmentPlatforms: r.tuple([r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "Set of fulfilment platforms." }).optional(),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "The name of the sales channel." }),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The shop ID." }),
	url: r.url().max(250)
}), O = r.array(r.object({ id: r.uuid().register(r.globalRegistry, { description: "The sales channel to extract orders for" }) })).min(1).max(25), k = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), A = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), j = r.object({ salesChannelIds: r.array(r.uuid()).min(1).max(100).register(r.globalRegistry, { description: "The sales channel IDs." }) }), M = r.object({
	salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	fulfilmentPlatforms: r.tuple([r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional()
}), N = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }) }), P = r.object({
	salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "The name of the sales channel." })
}), F = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), I = r.object({
	type: r.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: r.union([
		r.literal(400),
		r.literal(401),
		r.literal(404),
		r.literal(415),
		r.literal(500)
	]).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: r.string().min(1).max(100).register(r.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: r.string().min(1).max(5e3).register(r.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: r.url().register(r.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: r.unknown().register(r.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), ue = I.and(r.object({
	type: r.enum(["urn:problem:invalid-request-syntax"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string().min(1).max(5e3),
		pointer: r.string().min(1).max(200).register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(r.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), de = I.and(r.object({
	type: r.enum(["urn:problem:not-found"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(404).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), L = r.object({
	body: D,
	path: r.never().optional(),
	query: r.never().optional()
}), fe = r.union([r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(T), r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(C)]), R = r.object({
	body: O,
	path: r.never().optional(),
	query: r.never().optional()
}), z = r.object({
	body: k,
	path: r.never().optional(),
	query: r.never().optional()
}), pe = w.and(r.object({ extraction: r.object({
	lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: r.object({
		transformAndLoad: r.literal(!1),
		unit: S.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(r.globalRegistry, { description: "Order extraction configuration." }).optional() })), B = r.object({
	body: A,
	path: r.never().optional(),
	query: r.never().optional()
}), me = w.and(r.object({ extraction: r.object({
	lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: r.object({
		transformAndLoad: r.literal(!0),
		unit: S.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(r.globalRegistry, { description: "Order extraction configuration." }).optional() })), he = r.object({
	body: j,
	path: r.never().optional(),
	query: r.never().optional()
}), V = r.object({
	body: M,
	path: r.never().optional(),
	query: r.never().optional()
}), ge = E, H = r.object({
	body: N,
	path: r.never().optional(),
	query: r.never().optional()
}), _e = r.void().register(r.globalRegistry, { description: "Successful removal." }), U = r.object({
	body: P,
	path: r.never().optional(),
	query: r.never().optional()
}), ve = E, W = r.object({
	body: F,
	path: r.never().optional(),
	query: r.never().optional()
}), ye = r.union([r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(T), r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(C)]), G = r.object({
	body: r.never().optional(),
	path: r.never().optional(),
	query: r.object({ filter: r.object({ shopId: r.array(r.string().min(1).max(50)).min(1).max(100).optional() }).optional() }).optional()
}), be = r.object({ results: r.array(E).min(0).max(25) }).register(r.globalRegistry, { description: "Found sales channels." }), K = r.object({
	body: r.never().optional(),
	path: r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: r.never().optional()
}), xe = E, q = r.union([r.enum(["MINUTES"]), r.string()]), J = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({ lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(r.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: r.tuple([r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	delegationError: r.object({
		reason: r.string().register(r.globalRegistry, { description: "Error reason." }),
		details: r.string().register(r.globalRegistry, { description: "More detailed information about the error." }).optional()
	}).register(r.globalRegistry, { description: "Delegation error." }),
	status: r.union([r.enum(["DELEGATION_REQUIRED"]), r.string()]).register(r.globalRegistry, { description: "Connection status which indicates that a connection authorization is required." })
}), Y = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({
		lastCycle: r.object({
			extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
			successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
			transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
			successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
		}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
		schedule: r.object({
			transformAndLoad: r.boolean().register(r.globalRegistry, { description: "Whether orders should be automatically imported." }),
			unit: q.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
			value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
		}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
	}).register(r.globalRegistry, { description: "Order extraction configuration." }),
	fulfilmentPlatforms: r.tuple([r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	apiCredentialsLastTokens: r.object({ key: r.string().register(r.globalRegistry, { description: "API key." }) }).register(r.globalRegistry, { description: "Last N tokens when API credentials are used." }),
	status: r.union([r.enum(["DELEGATION_ISSUED"]), r.string()]).register(r.globalRegistry, { description: "Status for the connection with the sales channel for which orders will be extracted from." })
}), X = r.object({
	id: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	createdAt: r.iso.datetime().register(r.globalRegistry, { description: "Sales channel created at." }),
	extraction: r.object({ lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(r.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: r.tuple([r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: r.string().register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the Presta store." }),
	authorizeUrl: r.url().register(r.globalRegistry, { description: "Authorization URL for the sales channel." }),
	status: r.union([r.enum(["DELEGATION_REQUESTED"]), r.string()]).register(r.globalRegistry, { description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed." })
}), Z = r.union([
	r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(J),
	r.object({ status: r.literal("DELEGATION_ISSUED") }).and(Y),
	r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(X)
]), Se = r.object({
	fulfilmentPlatforms: r.tuple([r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "Set of fulfilment platforms." }).optional(),
	name: r.string().register(r.globalRegistry, { description: "The name of the sales channel." }),
	shopId: r.string().register(r.globalRegistry, { description: "The shop ID." }),
	url: r.url().max(250)
}), Ce = r.array(r.object({ id: r.uuid().register(r.globalRegistry, { description: "The sales channel to extract orders for" }) })), we = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), Te = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), Ee = r.object({ salesChannelIds: r.array(r.uuid()).register(r.globalRegistry, { description: "The sales channel IDs." }) }), De = r.object({
	salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }),
	fulfilmentPlatforms: r.tuple([r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })]).register(r.globalRegistry, { description: "The fulfilment platforms." }).optional()
}), Oe = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }) }), ke = r.object({
	salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }),
	name: r.string().register(r.globalRegistry, { description: "The name of the sales channel." })
}), Ae = r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The sales channel ID." }) }), je = r.object({
	type: r.union([r.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: r.union([
		r.literal(400),
		r.literal(401),
		r.literal(404),
		r.literal(415),
		r.literal(500)
	]).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: r.string().register(r.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: r.string().register(r.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: r.url().register(r.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: r.unknown().register(r.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
});
je.and(r.object({
	type: r.union([r.enum(["urn:problem:invalid-request-syntax"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string(),
		pointer: r.string().register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(r.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), je.and(r.object({
	type: r.union([r.enum(["urn:problem:not-found"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(404).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), r.object({
	body: Se,
	path: r.never().optional(),
	query: r.never().optional()
});
var Me = r.union([r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(X), r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(J)]);
r.object({
	body: Ce,
	path: r.never().optional(),
	query: r.never().optional()
}), r.object({
	body: we,
	path: r.never().optional(),
	query: r.never().optional()
});
var Ne = Y.and(r.object({ extraction: r.object({
	lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: r.object({
		transformAndLoad: r.literal(!1),
		unit: q.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(r.globalRegistry, { description: "Order extraction configuration." }).optional() }));
r.object({
	body: Te,
	path: r.never().optional(),
	query: r.never().optional()
});
var Pe = Y.and(r.object({ extraction: r.object({
	lastCycle: r.object({
		extractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: r.iso.datetime().register(r.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(r.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: r.object({
		transformAndLoad: r.literal(!0),
		unit: q.and(r.unknown().register(r.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: r.int().gt(0).register(r.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(r.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(r.globalRegistry, { description: "Order extraction configuration." }).optional() }));
r.object({
	body: Ee,
	path: r.never().optional(),
	query: r.never().optional()
}), r.object({
	body: De,
	path: r.never().optional(),
	query: r.never().optional()
});
var Fe = Z;
r.object({
	body: Oe,
	path: r.never().optional(),
	query: r.never().optional()
});
var Ie = r.void().register(r.globalRegistry, { description: "Successful removal." });
r.object({
	body: ke,
	path: r.never().optional(),
	query: r.never().optional()
});
var Le = Z;
r.object({
	body: Ae,
	path: r.never().optional(),
	query: r.never().optional()
});
var Re = r.union([r.object({ status: r.literal("DELEGATION_REQUESTED") }).and(X), r.object({ status: r.literal("DELEGATION_REQUIRED") }).and(J)]);
r.object({
	body: r.never().optional(),
	path: r.never().optional(),
	query: r.object({ filter: r.object({ shopId: r.array(r.string()).optional() }).optional() }).optional()
});
var ze = r.object({ results: r.array(Z) }).register(r.globalRegistry, { description: "Found sales channels." });
r.object({
	body: r.never().optional(),
	path: r.object({ salesChannelId: r.uuid().register(r.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: r.never().optional()
});
var Be = Z, Ve = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await L.parseAsync(e),
	responseValidator: async (e) => await Me.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), He = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await R.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/extract-orders",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ue = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await Ne.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/disable-order-loading",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), We = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await B.parseAsync(e),
	responseValidator: async (e) => await Pe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/enable-order-loading",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ge = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await he.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/import-products",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ke = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await Fe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/manage-inventory-for-imported-products",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qe = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await H.parseAsync(e),
	responseValidator: async (e) => await Ie.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Je = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await U.parseAsync(e),
	responseValidator: async (e) => await Le.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/rename-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ye = (e) => (e.client ?? x).post({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await Re.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/request-delegation",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Q = (e) => (e?.client ?? x).get({
	requestValidator: async (e) => await G.parseAsync(e),
	responseValidator: async (e) => await ze.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels",
	...e
}), Xe = (e) => (e.client ?? x).get({
	requestValidator: async (e) => await K.parseAsync(e),
	responseValidator: async (e) => await Be.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels/{salesChannelId}",
	...e
}), Ze = (e) => {
	let t = new URLSearchParams(), n = e.filter;
	return n && Object.entries(n).forEach(([e, n]) => {
		Array.isArray(n) ? n.forEach((n) => t.append(`filter[${e}]`, n)) : n !== void 0 && t.append(`filter[${e}]`, n);
	}), t.toString();
}, $ = (e) => {
	if (e instanceof i) throw Error(e.issues[0]?.message ?? e.message);
	if (typeof e == "object" && e && "status" in e && typeof e.status == "number") {
		let n = e.status;
		if (n === t.Unauthorized) throw Error("Unauthorized");
		if (n === t.NotFound && "detail" in e) throw Error(String(e.detail));
		if (n === t.BadRequest) {
			let t = e;
			if (t.errors && t.errors.length > 0) throw Error(t.errors[0].detail);
		}
	}
	throw Error(String(e));
}, Qe = () => x.getConfig().auth, $e = (t = { token: void 0 }) => {
	if (!t.token) throw Error("Token is required");
	let r = {
		baseUrl: n,
		auth: t.token
	};
	return t.environment && t.environment === "acceptance" && (r.baseUrl = e), t.locale && (r.headers = {
		...r.headers,
		"Accept-Language": t.locale
	}), x.setConfig(r), t.token;
}, et = (e) => {
	x.setConfig({ headers: {
		...x.getConfig().headers,
		"Accept-Language": e
	} });
}, tt = async (e) => {
	try {
		return (await Xe({ path: { salesChannelId: e } })).data;
	} catch (e) {
		$(e);
	}
}, nt = async (e = []) => {
	try {
		let t = {};
		return e.length > 0 && (t.query = { filter: { shopId: e } }, t.querySerializer = Ze), (await Q(t)).data;
	} catch (e) {
		$(e);
	}
}, rt = async (e) => {
	try {
		let { name: t, shopId: n, url: r } = e;
		return (await Ve({ body: {
			name: t,
			shopId: n,
			url: r
		} })).data;
	} catch (e) {
		$(e);
	}
}, it = async (e) => {
	try {
		await qe({ body: { salesChannelId: e } });
		return;
	} catch (e) {
		$(e);
	}
}, at = async (e) => {
	try {
		let { name: t, salesChannelId: n } = e;
		return (await Je({ body: {
			name: t,
			salesChannelId: n
		} })).data;
	} catch (e) {
		$(e);
	}
}, ot = async (e) => {
	try {
		return (await We({ body: { salesChannelId: e } })).data;
	} catch (e) {
		$(e);
	}
}, st = async (e) => {
	try {
		return (await Ue({ body: { salesChannelId: e } })).data;
	} catch (e) {
		$(e);
	}
}, ct = async (e) => {
	try {
		return await Ge({ body: { salesChannelIds: e } }), !0;
	} catch (e) {
		$(e);
	}
}, lt = async (e) => {
	try {
		return (await Ye({ body: { salesChannelId: e } })).data;
	} catch (e) {
		$(e);
	}
};
function ut() {
	return {
		createSalesChannel: rt,
		getSalesChannelById: tt,
		getSalesChannels: nt,
		removeSalesChannel: it,
		renameSalesChannel: at,
		requestDelegation: lt,
		enableOrderLoading: ot,
		disableOrderLoading: st,
		importProducts: ct,
		getToken: Qe,
		initClient: $e,
		setAcceptLanguageHeader: et
	};
}
//#endregion
export { R as A, I as B, M as C, pe as D, z as E, _e as F, F as G, de as H, U as I, T as J, E as K, ve as L, V as M, ge as N, B as O, H as P, W as R, j as S, fe as T, N as U, ue as V, P as W, x as X, C as Y, S as _, Ue as a, G as b, Ge as c, Je as d, Ye as f, O as g, A as h, Ve as i, he as j, me as k, Ke as l, k as m, Q as n, We as o, D as p, w as q, Xe as r, He as s, ut as t, qe as u, K as v, L as w, be as x, xe as y, ye as z };
